<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    
                    <div class="card-body px-lg-5 py-lg-5">
                      <transition name="fade">
                        <div  v-if="errorconnexion" 
                              class="alert alert-danger" 
                              role="alert">
                          Mauvaise combinaison email / mot de passe.
                        </div>
                        <div  v-if="goodconnexion" 
                              class="alert alert-success" 
                              role="alert">
                          Connexion...
                        </div>
                      </transition>
                      <form role="form">
                          <base-input class="input-group-alternative mb-3"
                                      placeholder="Email"
                                      addon-left-icon="ni ni-email-83"
                                      v-model="user.email">
                          </base-input>

                          <base-input class="input-group-alternative"
                                      placeholder="Mot de passe"
                                      type="password"
                                      addon-left-icon="ni ni-lock-circle-open"
                                      v-model="user.pwd">
                          </base-input>

                          <div class="text-center">
                              <base-button v-on:click="loginAction" type="primary" class="my-4">Connexion</base-button>
                          </div>
                      </form>
                    </div>
                </div>
                <div class="row mt-3">
                   
                </div>
            </div>
        </div>
</template>
<script> 
  import constvar from '@/const'
  import router from '@/router'

  export default {
    name: 'login',
    data() {
      return {
        user: {
          email: '',
          pwd: ''
        },
        errorconnexion: false,
        goodconnexion: false
      }
    },
    //Check if already connected
    created() {
      this.checklogin();
    },
    methods: {
      //Methods for checking login directly on load
      checklogin: async function() {
        const response = await fetch(constvar.api_url+'login', {
        method: 'POST',
        credentials: 'include',
        body: ''
        });
        const json = await response.json();
        //check if api return regenerated token
        if(json.code == 200 && json.message == "Token regenerated successfully.") {
          this.goodconnexion = true
          router.push("dashboard")    
        }
      },

      loginAction: async function() {
        const params = new URLSearchParams();
        params.append('email', this.user.email);
        params.append('pwd', this.user.pwd);
 
        const response = await fetch(constvar.api_url+'login', {
          method: 'POST',
          credentials: 'include',
          body: params
          });
        const json = await response.json();
        if(json.email == this.user.email) {
          this.goodconnexion = true
          router.push("dashboard")
        } else {
          this.errorconnexion = true
          setTimeout(()=>{
            this.errorconnexion = false
          },3000);
        } 
      }
    }
  }
</script>
<style>
</style>
